import { adminInfoSelector } from '../../profile/common/reducers/admin-profile.slice';
import { useSelector } from '../redux/store';
import createAvatar from '../utils/createAvatar';
import Avatar, { Props as AvatarProps } from './Avatar';

// ----------------------------------------------------------------------

export default function MyAvatar({ ...other }: AvatarProps) {
  const adminInfo = useSelector(adminInfoSelector);

  return (
    <Avatar
      src={adminInfo?.avatar?.url}
      alt={adminInfo?.name}
      color={createAvatar(adminInfo?.name as string).color || 'default'}
      {...other}
    >
      {createAvatar(adminInfo?.name as string).name}
    </Avatar>
  );
}
